module.exports = __webpack_public_path__ + "img/oliver-b-1.11b12822.png";